export default __webpack_public_path__ + "static/media/ic_maldives.19583579.svg";